import React, { useState } from 'react';
import { styled } from 'linaria/react';
import { css } from 'linaria';
import Image from '@jetshop/ui/Image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlayCircle as videoIcon } from '@fortawesome/pro-light-svg-icons';
import Popup from '../ui/Popup';

const VideoWrapper = styled('div')`
  margin-top: 1rem;
  button {
    width: 200px;
    position: relative;
    cursor: pointer img {
      filter: blur(1px);
      -webkit-filter: blur(1px);
    }
    svg {
      position: absolute;
      top: calc(50% - 35px);
      left: calc(50% - 35px);
      font-size: 5rem;
      color: white;
    }
  }
`;

const popupStyles = css`
  .popup-inner {
    background: black;
  }
  iframe {
    margin: 0 auto;
    display: block;
    max-width: 100%;
  }
`;

export const ProductVideo = ({ customData }) => {
  const [popup, setPopup] = useState(false);

  const videoData = customData.filter(item => {
    return item.key === 'data-youtube';
  });

  if (videoData.length) {
    const youtubeId = videoData[0].stringValue;
    const thumbSrc = `https://img.youtube.com/vi/${youtubeId}/0.jpg`;
    return (
      <VideoWrapper>
        <button
          onClick={() => {
            setPopup(true);
          }}
        >
          <Image src={thumbSrc} sizes={[50]} aspect={'4:3'} />
          <FontAwesomeIcon icon={videoIcon} />
        </button>
        {popup && (
          <Popup
            isOpen={true}
            className={popupStyles}
            closePopup={() => {
              setPopup(false);
            }}
          >
            <iframe
              width="800"
              height="600"
              title={youtubeId}
              src={`https://www.youtube.com/embed/${youtubeId}`}
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </Popup>
        )}
      </VideoWrapper>
    );
  } else return null;
};
